import IItineraryCategory from 'interfaces/IItineraryCategory';
import RestService from './RestService';

export default class ItineraryCategoryService extends RestService<IItineraryCategory> {
  constructor() {
    super('itinerary-categories');
  }
}
